import axios from 'axios'

const USER_NOTE_LIST_PATH = '/api/app/core/note/user/list'

/**
 * 分页查询当前用户笔记列表
 * @param {{ pageNum?: number, pageSize?: number }} [params]
 * @returns {Promise<{ records: Array, total: number, pageNum: number, pageSize: number }>}
 */
export async function fetchUserNoteList(params = {}) {
  const pageNum = params.pageNum != null ? params.pageNum : 1
  const pageSize = params.pageSize != null ? params.pageSize : 10
  const { data } = await axios.get(USER_NOTE_LIST_PATH, {
    params: { pageNum, pageSize }
  })
  return data && typeof data === 'object' ? data : { records: [], total: 0, pageNum, pageSize }
}

/**
 * 笔记内容预览（单行截断）
 * @param {string} content
 * @param {number} [maxLen]
 */
export function notePreview(content, maxLen = 120) {
  const text = content != null ? String(content).replace(/\s+/g, ' ').trim() : ''
  if (!text) return '暂无笔记内容'
  if (text.length <= maxLen) return text
  return `${text.slice(0, maxLen)}...`
}
